// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"PageTitle_pageTitle__k_Jpb","title":"PageTitle_title__Joqbo typography_H4__0XQc_ typography_FontBold__6lG0U"};